import * as React from 'react';
import { FC, useState } from 'react';
import fetchAPI from 'app/helpers/fetch';
import { AdventCalendarProps, Day, Choice } from './types';
import Calendar from './Calendar';
import Bonuses from './Bonuses';
import { LocalesContext } from './locales';
import { currentDay } from './days';

const useCalendar = (selectedDay: Day | undefined) => {
  const [submitting, setSubmitting] = useState(false);

  const onBonusChoose = (choice: Choice | undefined) => {
    if (!selectedDay?.offer || !choice) return Promise.resolve();

    setSubmitting(true);

    // eslint-disable-next-line consistent-return
    return fetchAPI(`/combo_bonus_offers/${selectedDay.offer.id}.json`, {
      method: 'PATCH',
      body: JSON.stringify({ combo_bonus_choice_id: choice.id }),
    })
      .then(() => {
        selectedDay.choice = choice;
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return [submitting, onBonusChoose] as const;
};

const AdventCalendar: FC<AdventCalendarProps> = ({ days, locales }) => {
  const [selectedDay, setSelectedDay] = useState(currentDay(days));
  const [submitting, onBonusChoose] = useCalendar(selectedDay);

  return (
    <LocalesContext.Provider value={locales}>
      <div className={`advent_calendar_widget ${submitting ? 'submitting' : ''}`}>
        <Calendar days={days} selectedDay={selectedDay} onSelect={setSelectedDay} />
        <Bonuses day={selectedDay} onBonusChoose={onBonusChoose} />
        {submitting && <div className="overlay" />}
      </div>
    </LocalesContext.Provider>
  );
};

export default AdventCalendar;
